import React from "react";
import Box from "@mui/material/Box";
import NewMatching from "../organisms/NewMatching";
import Notification from "../organisms/Notification";
import MatchingHistory from "../organisms/MatchingHistory";
import ActivePersonnels from "../organisms/ActivePersonnels";
import PersonDistribution from "../organisms/PersonDistribution";
import { BigHeadline } from "../../../../components/TextParts";
import ConditionDialog from "../organisms/ConditionDialog";
import "../../../../style/App.css";

export default function DashboardTemplate() {
  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: "auto",
        }}
      >
        <Box
          className="App"
          sx={{
            display: "flex",
            gap: "20px",
            marginTop: { xs: "0px", sm: "40px" },
          }}
        >
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <ActivePersonnels />
          </Box>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <PersonDistribution />
          </Box>
        </Box>

        <NewMatching />

        <MatchingHistory />

        <BigHeadline text="お知らせ" />
        <Notification />
        <ConditionDialog />
      </Box>
    </Box>
  );
}